import React from "react";
import { SimpleShowLayout, TextField } from "react-admin";

const Tab = (props) => {
  return (
    <SimpleShowLayout {...props}>
      <TextField source="baseball.id" />
      <TextField source="baseball.playerGameCount" />
      <TextField source="baseball.hits" />
      <TextField source="baseball.atBats" />
      <TextField source="baseball.runs" />
      <TextField source="baseball.doubles" />
      <TextField source="baseball.triples" />
      <TextField source="baseball.homeRuns" />
      <TextField source="baseball.runsBattedIn" />
      <TextField source="baseball.stolenBases" />
      <TextField source="baseball.battingAverage" />
      <TextField source="baseball.inningsPitched" />
      <TextField source="baseball.runsAllowed" />
      <TextField source="baseball.earnedRuns" />
      <TextField source="baseball.hitsAllowed" />
      <TextField source="baseball.basesOnBalls" />
      <TextField source="baseball.strikeouts" />
      <TextField source="baseball.pitchingWins" />
      <TextField source="baseball.pitchingLosses" />
      <TextField source="baseball.saves" />
      <TextField source="baseball.earnedRunAverage" />
    </SimpleShowLayout>
  );
};

export default Tab;
